const MADINA_INFO = {
  address: '15 Victoria Arobieke, Off Admiralty Wy, Lekki Phase 1, Lekki 234011, Lagos',
  email: 'support@madina.ng',
  phone: '+2348186177465',
  whatsApp: 'https://wa.link/9wzx0n',
  name: 'Madina Lifestyle Supermarket'
} as const;

export default MADINA_INFO;
